"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = _interopRequireDefault(require("./colors"));
var _utils = require("./utils");
const mds = {
  brand: (0, _utils.getFonts)(),
  core: (0, _utils.getCore)(),
  theme: (0, _utils.getTheme)()
};
const fonts = {
  body: mds.brand['font--default-font-family'],
  heading: mds.brand['font-family-display']
};
const fontWeights = {
  light: Number(mds.brand['font-weight-light']),
  regular: Number(mds.brand['font-weight-regular']),
  bold: Number(mds.brand['font-weight-bold'])
};
const breakpoints = ['544px', '768px', '1012px', '1280px'];
const borderWidths = [0, mds.core['border-width']];
const sizes = {
  small: '544px',
  medium: '768px',
  large: '1012px',
  xlarge: '1280px'
};
const fontSizes = {
  xs: mds.brand['font-size-xs'],
  s: mds.brand['font-size-s'],
  m: mds.brand['font-size-m'],
  l: mds.brand['font-size-l'],
  '12': mds.brand['font-size-xs'],
  '14': mds.brand['font-size-s'],
  '16': mds.brand['font-size-l'],
  '20': mds.brand['font--display-1-font-size'],
  '26': mds.brand['font--display-2-font-size'],
  '38': mds.brand['font--display-4-font-size-mobile'],
  '40': mds.brand['font--display-3-font-size'],
  '50': mds.brand['font--display-4-font-size'],
  '56': mds.brand['font--display-5-font-size-mobile'],
  '80': mds.brand['font--display-5-font-size']
};
const iconSize = {
  small: mds.brand['font--display-1-font-size'],
  medium: '24px'
};
const lineHeights = {
  xs: mds.brand['font-line-height-xs'],
  s: mds.brand['font-line-height-s'],
  m: mds.brand['font-line-height-m'],
  '16': mds.brand['font-line-height-xs'],
  '20': mds.brand['font-line-height-s'],
  '24': mds.brand['font-line-height-m'],
  '32': mds.brand['font--display-2-font-line-height'],
  '40': mds.brand['font--display-3-font-line-height'],
  '48': '48px',
  '56': mds.brand['font--display-4-font-line-height'],
  '80': mds.brand['font--display-5-font-line-height']
};
const space = {
  '-1': '-1px',
  '0': '0',
  '1': mds.core['spacing-1px'],
  '2': mds.core['spacing-2px'],
  '3': mds.core['spacing-3px'],
  '4': mds.core['spacing-4px'],
  '5': mds.core['spacing-5px'],
  '6': mds.core['spacing-6px'],
  '7': mds.core['spacing-7px'],
  '8': mds.core['spacing-8px'],
  '9': mds.core['spacing-9px'],
  '10': mds.core['spacing-10px'],
  '11': mds.core['spacing-11px'],
  '12': mds.core['spacing-12px'],
  '13': mds.core['spacing-13px'],
  '14': mds.core['spacing-14px'],
  '15': mds.core['spacing-15px'],
  '16': mds.core['spacing-16px'],
  '17': mds.core['spacing-17px'],
  '18': mds.core['spacing-18px'],
  '19': mds.core['spacing-19px'],
  '20': mds.core['spacing-20px'],
  '22': mds.core['spacing-22px'],
  '23': mds.core['spacing-23px'],
  '24': mds.core['spacing-24px'],
  '26': mds.core['spacing-26px'],
  '28': mds.core['spacing-28px'],
  '30': mds.core['spacing-30px'],
  '32': mds.core['spacing-32px'],
  '33': mds.core['spacing-33px'],
  '34': mds.core['spacing-34px'],
  '36': mds.core['spacing-36px'],
  '38': mds.core['spacing-38px'],
  '39': mds.core['spacing-39px'],
  '40': mds.core['spacing-40px'],
  '42': mds.core['spacing-42px'],
  '44': mds.core['spacing-44px'],
  '46': mds.core['spacing-46px'],
  '47': mds.core['spacing-47px'],
  '48': mds.core['spacing-48px'],
  '56': mds.core['spacing-56px'],
  '64': '64px',
  '78': '78px',
  '80': '80px'
};
const boxShadows = {
  card: {
    1: mds.theme['box-shadow-1'],
    2: mds.theme['box-shadow-2'],
    3: mds.theme['box-shadow-3'],
    4: mds.theme['box-shadow-4'],
    5: mds.theme['box-shadow-5'],
    6: mds.theme['box-shadow-6'],
    7: mds.theme['box-shadow-7'],
    8: mds.theme['box-shadow-8'],
    9: mds.theme['box-shadow-9'],
    l: mds.theme['box-shadow-l'],
    m: mds.theme['box-shadow-m'],
    s: mds.theme['box-shadow-s'],
    xs: mds.theme['box-shadow-xs']
  },
  tooltip: {
    'box-shadow-tooltip--default': mds.theme['box-shadow-tooltip--default'],
    'box-shadow-tooltip--inverse': mds.theme['box-shadow-tooltip--inverse']
  },
  type: {
    basic: {
      "default": "0 0 0 3px ".concat(_colors["default"].primary.blue[50]),
      danger: "0 0 0 3px ".concat(_colors["default"].feedback.danger.light)
    },
    vanity: {
      "default": "0 3px 0 0 ".concat(_colors["default"].primary.blue[50]),
      danger: "0 3px 0 0 ".concat(_colors["default"].feedback.danger.light)
    },
    "switch": {
      "default": "0 0 0 3px ".concat(_colors["default"].functional.grey[200])
    }
  }
};
const borderProperties = {
  "switch": {
    verticalBorder: '1px solid rgba(20, 20, 20, 0.1)',
    select: {
      "default": "0 0 0 3px ".concat(_colors["default"].primary.blue[50]),
      danger: "0 0 0 3px ".concat(_colors["default"].feedback.danger.light),
      vanityDefault: "0 3px 0 0 ".concat(_colors["default"].primary.blue[50]),
      vanityDanger: "0 3px 0 0 ".concat(_colors["default"].feedback.danger.light)
    }
  }
};
const borderRadius = {
  s: mds.core['border-radius-s'],
  m: mds.core['border-radius-m'],
  l: mds.core['border-radius-l'],
  xl: '10px',
  xxl: mds.core['border-radius-xxl']
};
const strokeColors = {
  plain: "".concat(_colors["default"].functional.grey['50'], "15")
};
const typography = {
  variants: {
    h1: {
      fontSize: mds.brand['font--display-5-font-size'],
      lineHeight: mds.brand['font--display-5-font-line-height'],
      fontFamily: mds.brand['font--display-5-font-family'],
      fontWeight: mds.brand['font--display-5-font-weight'],
      fontStyle: mds.brand['font--display-5-font-style'],
      letterSpacing: mds.brand['font--display-5-font-letter-spacing']
    },
    h2: {
      fontSize: mds.brand['font--display-4-font-size'],
      lineHeight: mds.brand['font--display-4-font-line-height'],
      fontFamily: mds.brand['font--display-4-font-family'],
      fontWeight: mds.brand['font--display-4-font-weight'],
      fontStyle: mds.brand['font--display-4-font-style'],
      letterSpacing: mds.brand['font--display-4-font-letter-spacing']
    },
    h3: {
      fontSize: mds.brand['font--display-3-font-size'],
      lineHeight: mds.brand['font--display-3-font-line-height'],
      fontFamily: mds.brand['font--display-3-font-family'],
      fontWeight: mds.brand['font--display-3-font-weight'],
      fontStyle: mds.brand['font--display-3-font-style'],
      letterSpacing: mds.brand['font--display-3-font-letter-spacing']
    },
    h4: {
      fontSize: mds.brand['font--display-2-font-size'],
      lineHeight: mds.brand['font--display-2-font-line-height'],
      fontFamily: mds.brand['font--display-2-font-family'],
      fontWeight: mds.brand['font--display-2-font-weight'],
      fontStyle: mds.brand['font--display-2-font-style'],
      letterSpacing: mds.brand['font--display-2-font-letter-spacing']
    },
    h5: {
      fontSize: mds.brand['font--display-1-font-size'],
      lineHeight: mds.brand['font--display-1-font-line-height'],
      fontFamily: mds.brand['font--display-1-font-family'],
      fontWeight: mds.brand['font--display-1-font-weight'],
      fontStyle: mds.brand['font--display-1-font-style'],
      letterSpacing: mds.brand['font--display-1-font-letter-spacing']
    },
    h6: {
      fontSize: mds.brand['font--default-font-size'],
      lineHeight: mds.brand['font--default-font-line-height'],
      fontFamily: mds.brand['font--default-font-family'],
      fontWeight: mds.brand['font--default-font-weight'],
      fontStyle: mds.brand['font--default-font-style'],
      letterSpacing: mds.brand['font--default-font-letter-spacing']
    },
    body1: {
      fontSize: mds.brand['font--default-font-size'],
      lineHeight: mds.brand['font--default-font-line-height'],
      fontFamily: mds.brand['font--default-font-family'],
      fontWeight: mds.brand['font--default-font-weight'],
      fontStyle: mds.brand['font--default-font-style'],
      letterSpacing: mds.brand['font--default-font-letter-spacing']
    },
    body2: {
      fontSize: mds.brand['font--small-font-size'],
      lineHeight: mds.brand['font--small-font-line-height'],
      fontFamily: mds.brand['font--small-font-family'],
      fontWeight: mds.brand['font--small-font-weight'],
      fontStyle: mds.brand['font--small-font-style'],
      letterSpacing: mds.brand['font--small-font-letter-spacing']
    }
  },
  fontStyle: {
    normal: {
      fontStyle: mds.brand['font--default-font-style'],
      fontWeight: mds.brand['font--default-font-weight']
    },
    bold: {
      fontStyle: mds.brand['font--default--bold-font-style'],
      fontWeight: mds.brand['font--default--bold-font-weight']
    },
    italic: {
      fontStyle: mds.brand['font--default--italic-font-style'],
      fontWeight: mds.brand['font--default--italic-font-weight']
    },
    boldItalic: {
      fontStyle: mds.brand['font--default--bolditalic-font-style'],
      fontWeight: mds.brand['font--default--bolditalic-font-weight']
    }
  }
};
const zindexes = [9, 99, 999, 9999, 99999, 999999, 9999999];
const modal = {
  backdrop: mds.theme['background-color-scrim'],
  fit: {
    s: {
      width: mds.core['modal-width-s'],
      height: mds.core['modal-height-s'],
      minHeight: mds.core['modal-min-height-s']
    },
    m: {
      width: mds.core['modal-width-m'],
      height: mds.core['modal-height-m'],
      minHeight: mds.core['modal-min-height-m']
    },
    l: {
      width: mds.core['modal-width-l'],
      height: mds.core['modal-height-l'],
      minHeight: mds.core['modal-min-height-l']
    }
  }
};
const transition = {
  'transition-duration': mds.core['transition-duration'],
  'transition-duration-medium': mds.core['transition-duration-medium'],
  'transition-delay': mds.core['transition-delay'],
  'transition-timing-function': mds.core['transition-timing-function'],
  transition: mds.core['transition'],
  'transition-medium': mds.core['transition-medium']
};
const theme = {
  borderWidths,
  borderRadius,
  boxShadows,
  breakpoints,
  colors: _colors["default"],
  strokeColors,
  fonts,
  fontSizes,
  fontWeights,
  sizes,
  space,
  typography,
  iconSize,
  lineHeights,
  zindexes,
  borderProperties,
  modal,
  transition,
  mds
};
var _default = exports["default"] = theme;